import script from "./CreateOrderFlow.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateOrderFlow.vue?vue&type=script&setup=true&lang=js"

import "./CreateOrderFlow.vue?vue&type=style&index=0&id=98d11180&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98d11180"]])

export default __exports__